import React__default from 'react';
import { UnitPrice, BestPrice } from '@grandvisionhq/common';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { getLocalizedString } from '@grandvisionhq/utils';
import { useDiscountLabel } from './helpers/use-discount-label.js';
import { useProductDetailSlots } from '../../../../slots/context.js';
import { ProductDetailPrice } from './components/ProductDetailPrice/ProductDetailPrice.js';
import { Discount } from './components/Discount/Discount.js';
import { PriceDisclaimerContainer } from './components/PriceDisclaimer/PriceDisclaimerContainer.js';

const PriceSection = ({ originalPrice , orignalPriceCurrencyCode , discountedPrice , discountCurrencyCode , discountInformation , pricePerUnit , bestPrice ,  })=>{
    const { getLabel , locale  } = useIntl();
    const { isBestPriceEnabled , isPricePerUnitEnabled , featureConfigs: { unitPriceFixedDecimalsConfig  } = {} ,  } = useFeatureToggles();
    const { Slots  } = useProductDetailSlots();
    const discount = useDiscountLabel(discountInformation === null || discountInformation === void 0 ? void 0 : discountInformation.value, discountInformation === null || discountInformation === void 0 ? void 0 : discountInformation.type, discountCurrencyCode, locale);
    const discountIsZero = discountedPrice === originalPrice;
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: "price-section",
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "price-section__price-row"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "price-section__price-wrapper"
    }, /*#__PURE__*/ React__default.createElement(ProductDetailPrice, {
        centAmount: false,
        originalPrice: originalPrice,
        discountedPrice: discountedPrice,
        currency: orignalPriceCurrencyCode
    })), isPricePerUnitEnabled && pricePerUnit && /*#__PURE__*/ React__default.createElement(UnitPrice, {
        amount: pricePerUnit.amount,
        currencyCode: pricePerUnit.currencyCode,
        fixedDecimals: unitPriceFixedDecimalsConfig === null || unitPriceFixedDecimalsConfig === void 0 ? void 0 : unitPriceFixedDecimalsConfig.pdp
    })), !!discount && !discountIsZero && /*#__PURE__*/ React__default.createElement(Discount, {
        discount: discount,
        label: getLocalizedString(discountInformation === null || discountInformation === void 0 ? void 0 : discountInformation.description, locale),
        isWide: true
    }), /*#__PURE__*/ React__default.createElement(PriceDisclaimerContainer, null), /*#__PURE__*/ React__default.createElement(BestPrice, {
        isFeatureEnabled: isBestPriceEnabled,
        amount: bestPrice,
        isCentAmount: false,
        currencyCode: orignalPriceCurrencyCode,
        discountedPrice: discountedPrice,
        originalPrice: originalPrice,
        className: "price-section__best-price"
    })), Slots.AfterPrice && /*#__PURE__*/ React__default.createElement(Slots.AfterPrice, null));
};

export { PriceSection };
//# sourceMappingURL=PriceSection.js.map
